import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import { initializeAdminThemeMode } from './app/theme-mode';
import { applyWanjianshiBranding } from './branding/applyBranding';
import './styles/global.css';

applyWanjianshiBranding();
initializeAdminThemeMode();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
